import script from "./ComparisonSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonSection.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonSection.vue?vue&type=style&index=0&id=471bdb0f&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471bdb0f"]])

export default __exports__